/**
 * Shaliach activity log — shared between backend filtering and the frontend timeline,
 * so a changed field lands in the same category on both sides.
 */

export const SHALIACH_ACTIVITY_CATEGORIES = {
  personal: {
    label: 'פרטים אישיים',
    fields: [
      'firstName',
      'lastName',
      'nickName',
      'publicName',
      'title',
      'dateOfBirth',
      'jewishDateOfBirth',
      'tid',
      'fatherId',
      'motherId',
      'fatherName',
      'motherName',
      'spouseId',
      'spouseName',
      'children',
      'childrenNames',
      'aboutMe',
      'profileImage',
      'familyImage',
      'personalImage',
      'videoUrl'
    ]
  },
  contact: {
    label: 'פרטי קשר',
    fields: ['phone', 'mail', 'phoneWa', 'publicPhone', 'fullAddress', 'mikoud']
  },
  role: {
    label: 'תפקיד ושיוך',
    fields: [
      'status',
      'role',
      'type',
      'position',
      'branchId',
      'branchName',
      'subBranchName',
      'merchav',
      'isAdmin',
      'isEditor'
    ]
  },
  tags: {
    label: 'תגיות',
    fields: ['tags', 'activities']
  },
  subscription: {
    label: 'מנוי',
    fields: ['subscriptionType']
  },
  finance: {
    label: 'כספים',
    fields: [
      'creditInTheMLS',
      'malashId',
      'bankAccountName',
      'bankBranchNum',
      'bankAccountNum',
      'bankNum',
      'bankAccountDoc'
    ]
  }
} as const;

export type ShaliachActivityCategory = keyof typeof SHALIACH_ACTIVITY_CATEGORIES | 'other';

/** Fields stored as a whole list (old/new arrays) — shown as per-item added/removed lines. */
export const SHALIACH_ACTIVITY_LIST_FIELDS: readonly string[] = SHALIACH_ACTIVITY_CATEGORIES.tags.fields;

// reduce rather than flatMap: the types lib compiles against an ES2017 lib
export const SHALIACH_ACTIVITY_KNOWN_FIELDS: readonly string[] = Object.values(SHALIACH_ACTIVITY_CATEGORIES).reduce<
  string[]
>((fields, category) => [...fields, ...category.fields], []);

export const getShaliachActivityCategory = (field?: string | null): ShaliachActivityCategory => {
  if (!field) return 'other';
  const entry = Object.entries(SHALIACH_ACTIVITY_CATEGORIES).find(([, category]) =>
    (category.fields as readonly string[]).includes(field)
  );
  return (entry?.[0] as ShaliachActivityCategory) ?? 'other';
};

/** Action types the log can be filtered by. `field` = a regular field change. */
export type ShaliachActivityActionType = 'field' | 'listAdd' | 'listRemove' | 'message';
